/* Friendly Turtle upgrade-safe customisations. */
(function () {
  'use strict';

  var focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';

  function ensureHeaderSearch() {
    if (document.querySelector('.friendly-turtle-header-search')) return;

    var nav = document.querySelector('.header-wrapper.nav__option-full .nav-container');
    if (!nav) return;

    var logo = nav.querySelector('#logo');
    var headerLinks = nav.querySelector('.shopping__cart-links');
    if (!logo || !headerLinks) return;

    var form = document.createElement('form');
    form.className = 'search-form friendly-turtle-header-search';
    form.action = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'search' : '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');

    var label = document.createElement('label');
    label.className = 'visually-hidden';
    label.setAttribute('for', 'FriendlyTurtleHeaderSearch');
    label.textContent = 'Search';

    var input = document.createElement('input');
    input.id = 'FriendlyTurtleHeaderSearch';
    input.type = 'search';
    input.name = 'q';
    input.placeholder = 'Search for items and articles';
    input.setAttribute('aria-label', 'Search');
    input.autocomplete = 'off';

    try {
      var query = new URLSearchParams(window.location.search).get('q');
      if (query) input.value = query;
    } catch (e) {}

    form.appendChild(label);
    form.appendChild(input);
    nav.insertBefore(form, headerLinks);
  }

  function syncCarouselItem(item) {
    if (!item || !item.matches || !item.matches('.flickity-slider [aria-hidden]')) return;
    var isHidden = item.getAttribute('aria-hidden') === 'true';

    item.querySelectorAll(focusableSelector).forEach(function (element) {
      if (isHidden) {
        if (!element.hasAttribute('data-a11y-original-tabindex')) {
          var originalTabindex = element.getAttribute('tabindex');
          element.setAttribute('data-a11y-original-tabindex', originalTabindex === null ? 'none' : originalTabindex);
        }
        element.setAttribute('tabindex', '-1');
      } else if (element.hasAttribute('data-a11y-original-tabindex')) {
        var savedTabindex = element.getAttribute('data-a11y-original-tabindex');
        if (savedTabindex === 'none') element.removeAttribute('tabindex');
        else element.setAttribute('tabindex', savedTabindex);
        element.removeAttribute('data-a11y-original-tabindex');
      }
    });
  }

  function labelWishlistLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('#swym-inject-header, a.swym-inject[href="#swym-wishlist"]').forEach(function (link) {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Open wishlist');
    });
  }

  function initialise(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.flickity-slider [aria-hidden]').forEach(syncCarouselItem);
    labelWishlistLinks(scope);
    ensureHeaderSearch();
  }

  function start() {
    initialise(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          syncCarouselItem(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.flickity-slider [aria-hidden]')) syncCarouselItem(node);
          initialise(node);
        });
      });
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
